import { useAuth } from "react-oidc-context";

function SignedOut() {
  const auth = useAuth();

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-gradient-to-br"
      style={{ backgroundImage: "linear-gradient(to bottom right, #E6DCFF, #fffce9ff)" }}
    >
      <div className="bg-white shadow-md rounded-lg p-10 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">
          You’ve been signed out successfully.
        </h2>
        <button
          onClick={() => auth.signinRedirect()}
          className="mt-4 px-6 py-2 text-white font-semibold rounded-md"
          style={{ backgroundColor: "#7500c0" }}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
}

export default SignedOut;
